import { T } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { NoSSR } from '@flipster/react/misc/lifecycle/NoSSR';
import { css } from '@flipster/styled-system/css';
import { Link } from '@flipster/ui';
import TradingPauseIcon from '@flipster/ui/assets/svgs/trading-pause.svg';
import { numberFormatter } from '@flipster/utils/num';

import { zendesk } from '../zendesk/url';
import { useTradingPause } from './state';

type Placement = 'left-end' | 'left-start' | 'top' | 'bottom' | 'left' | 'right';

interface Props {
  symbol: string;
  position: Placement;
}

export const getTooltipPosition = (index: number): Placement => (index < 3 ? 'left-end' : 'left-start');

export const TradingPauseTooltipIcon = ({ symbol, position }: Props) => {
  const { pauseDuration, status } = useTradingPause(symbol);

  if (status === 'None') return null;

  return (
    <Tooltip placement={position} maxWidth={240}>
      <Tooltip.Trigger
        css={{
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            w: 20,
            h: 20,
            mr: 8,
          },
        }}
      >
        <TradingPauseIcon />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <p>
          <T
            id='Assets.r250401.Potential_trading_pause_description'
            values={{ interval: numberFormatter(pauseDuration) }}
          />
        </p>
        <NoSSR>
          <Link
            href={zendesk.getUrl('TradingPause')}
            size='small'
            shape='link1'
            className={css({ color: 'legacy.yellow', textDecoration: 'underline' })}
            underline
            opener
            external
          >
            <T id='Common.r250401.Learn_more' />
          </Link>
        </NoSSR>
      </Tooltip.Content>
    </Tooltip>
  );
};
